import produce from "immer";
import { createAsyncAction } from "typesafe-actions";
import { ActionType, createReducer } from "typesafe-actions";
import { APICallStatus, ToDo } from "../../../Types/UnitFeatureTypes";


export interface FetchToDoInfoState {
  request: {
      loading: boolean;
      error: string | null;
      singleTask: ToDo | null;
      data: ToDo[] | null;
      count: string | null;
  };
}

export enum Types {
  FETCH_TODO_REQUEST = 'FETCH_TODO_REQUEST',
  FETCH_TODO_SUCCESS = 'FETCH_TODO_SUCCESS',
  FETCH_TODO_FAILURE = 'FETCH_TODO_FAILURE',
}

const toDoActions = createAsyncAction(
  Types.FETCH_TODO_REQUEST,
  Types.FETCH_TODO_SUCCESS,
  Types.FETCH_TODO_FAILURE,
)
<
  { id?: string, offset?: number, sortColumn?: string, sortDirection?: string },
  { tasks?: ToDo[], task?: ToDo, count: string },
  { message: string }
>();

export const Actions = { toDoActions };

export const initialState: FetchToDoInfoState = {
  request: {
    loading: false,
    error: null as string | null,
    singleTask: null,
    data: null,
    count: '0'
  }
};

export type FetchToDoState = typeof initialState;


const fetchToDoRequest = (state: FetchToDoState) =>
  produce(state, draft => {
    draft.request.loading = true;
    draft.request.error = null;
  });

  const fetchToDoSuccess = (
    state = initialState,
    { payload }: ActionType<typeof Actions.toDoActions.success>
  ) =>
  produce(state, draft => {
    draft.request.loading = false;
    draft.request.error = null;
    
    draft.request.data = payload.tasks ?? null;
    draft.request.singleTask = payload.task ?? null;
    
    draft.request.count = payload.count;
  });

  const fetchToDoFailure = (
    state = initialState,
    { payload }: ActionType<typeof Actions.toDoActions.failure>
  ) =>
    produce(state, draft => {
      draft.request.loading = false;
      draft.request.error = payload.message;
    });

export default createReducer<typeof initialState, ActionType<typeof Actions>>(
  initialState
)
  .handleAction(toDoActions.request, fetchToDoRequest)
  .handleAction(toDoActions.success, fetchToDoSuccess)
  .handleAction(toDoActions.failure, fetchToDoFailure);
  